import { render } from "./ExtRedirPage.vue?vue&type=template&id=2cf1a5cc"
import script from "./ExtRedirPage.vue?vue&type=script&lang=js"
export * from "./ExtRedirPage.vue?vue&type=script&lang=js"

import "./ExtRedirPage.vue?vue&type=style&index=0&id=2cf1a5cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__